import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './CustomTable.scss';
import ArrowDropDownIcon from '../Icons/ArrowDropDownIcon';
import ArrowDropUpIcon from '../Icons/ArrowDropUpIcon';

const rootClassName = styles.rootClassName;

export const ORDER_ASC = 'ORDER_ASC';
export const ORDER_DESC = 'ORDER_DESC';

class CustomTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currWidth: null,
      columnRefs: props.columns.map(() => {
        return React.createRef();
      }),
      orderByColumnIndex: props.orderByColumnIndex || 0,
      order: props.order || ORDER_ASC,
    };
  }

  withMaxHeight = () => {
    return typeof this.props.maxHeight === 'number' && this.props.maxHeight > 0
      ? true
      : false;
  };

  updateDimensions = () => {
    this.setState({
      currWidth: window.innerWidth,
    });
  };

  UNSAFE_componentWillReceiveProps() {
    this.setState({
      orderByColumnIndex: this.props.orderByColumnIndex || 0,
      order: this.props.order || ORDER_ASC,
    });
  }

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  needRender = () => {
    if (!this.state.columnRefs[0].current) {
      this.forceUpdate();
    }
  };

  setOrderByColumnIndex = (columnIndex) => {
    let currColumnIndex = this.state.orderByColumnIndex;
    let newState = {
      orderByColumnIndex: columnIndex,
    };
    if (currColumnIndex !== columnIndex) {
      newState.order = ORDER_ASC;
    } else {
      newState.order = this.state.order === ORDER_ASC ? ORDER_DESC : ORDER_ASC;
    }
    this.setState(newState);
  };

  getLines = () => {
    if (this.props.lockReorder) {
      return this.props.lines;
    }
    return this.props.lines.sort((a, b) => {
      if (this.state.order === ORDER_ASC) {
        if (
          a.columns[this.state.orderByColumnIndex].value.toLowerCase() <
          b.columns[this.state.orderByColumnIndex].value.toLowerCase()
        ) {
          return -1;
        }
        return 1;
      } else {
        if (
          a.columns[this.state.orderByColumnIndex].value.toLowerCase() >
          b.columns[this.state.orderByColumnIndex].value.toLowerCase()
        ) {
          return -1;
        }
        return 1;
      }
    });
  };

  getOrderIcon = () => {
    const className = rootClassName + '-order-icon';
    return this.state.order === ORDER_ASC ? (
      <ArrowDropDownIcon className={className} />
    ) : (
      <ArrowDropUpIcon className={className} />
    );
  };

  render() {
    const wrapperProps = {
      className: getMergedClassNames([rootClassName + '-wrapper']),
    };
    const scrollWrapperProps = {
      className: getMergedClassNames([
        rootClassName + '-scroll-wrapper',
        this.withMaxHeight()
          ? rootClassName + '-scroll-wrapper-with-max-height'
          : '',
      ]),
      style: {
        maxHeight: this.props.maxHeight,
      },
    };
    const tableProps = {
      className: getMergedClassNames([
        rootClassName + '-table',
        'table',
        this.props.lockReorder ? rootClassName + '-disable-reorder' : '',
        this.props && this.props.className ? this.props.className : '',
      ]),
    };
    return (
      <div {...wrapperProps}>
        <div {...scrollWrapperProps}>
          <table {...tableProps}>
            <thead>
              <tr>
                {this.props.columns.map((column, index) => {
                  let columnProps = {
                    ...(column.props || {}),
                  };
                  if (this.withMaxHeight()) {
                    columnProps.style = {
                      ...(columnProps.style || {}),
                      width: this.state.columnRefs[index].current
                        ? window.getComputedStyle(
                            this.state.columnRefs[index].current
                          ).width
                        : '0',
                    };
                  }
                  return (
                    <th
                      {...columnProps}
                      key={index}
                      onClick={() =>
                        this.props.lockReorder
                          ? false
                          : this.setOrderByColumnIndex(index)
                      }
                    >
                      {column.name}
                      {this.state.orderByColumnIndex === index
                        ? this.getOrderIcon()
                        : null}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {this.getLines().map((line, lineIndex) => {
                return (
                  <tr {...(line.props || {})} key={lineIndex}>
                    {line.columns.map((column, columnIndex) => {
                      let columnProps = { ...(column.props || {}) };
                      if (this.withMaxHeight()) {
                        columnProps.ref =
                          lineIndex === 0 &&
                          this.props.lines.length > columnIndex
                            ? this.state.columnRefs[columnIndex]
                            : null;
                      }
                      return (
                        <td {...columnProps} key={columnIndex}>
                          {column.value}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {this.withMaxHeight() ? this.needRender() : ''}
      </div>
    );
  }
}

CustomTable.propTypes = {
  maxHeight: PropTypes.number,
  columns: PropTypes.arrayOf(
    PropTypes.exact({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
      props: PropTypes.object,
    })
  ).isRequired,
  lines: PropTypes.arrayOf(
    PropTypes.exact({
      columns: PropTypes.arrayOf(
        PropTypes.exact({
          value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
          props: PropTypes.object,
        })
      ),
      props: PropTypes.object,
    })
  ).isRequired,
  props: PropTypes.object,
  orderByColumnIndex: PropTypes.number,
  order: PropTypes.oneOf([ORDER_ASC, ORDER_DESC]),
  lockReorder: PropTypes.bool,
};

export default CustomTable;
